export class ItemsListOptions {
    constructor(private _attributes: angular.IAttributes) {
    }

    get itemIdProperty(): string {
        return this.getAttributeValue('itemIdProperty');
    }

    get itemIconProperty(): string {
        return this.getAttributeValue('itemIconProperty');
    }

    get itemIconTooltipProperty(): string {
        return this.getAttributeValue('itemIconTooltipProperty');
    }

    get itemHeaderProperty(): string {
        return this.getAttributeValue('itemHeaderProperty');
    }

    get itemRightHeaderProperty(): string {
        return this.getAttributeValue('itemRightHeaderProperty');
    } 

    get isItemRightHeaderNumberProperty(): boolean {
        var prop = this.getAttributeValue('isItemRightHeaderNumberProperty');
        if (prop != undefined
            && prop.length > 0)
            return Boolean(prop);
        else
            return false;
    }

    get itemRightHeaderNumberOfDecimalsProperty(): number {
        var prop = this.getAttributeValue('itemRightHeaderNumberOfDecimalsProperty');
        if (prop != undefined
            && prop.length > 0)
            return Number(prop);
        else
            return 0;
    }
    
    get itemRightHeaderUomProperty(): string {
        return this.getAttributeValue('itemRightHeaderUomProperty');
    } 

    get metaDataProperties(): Array<string> {
        const properties = this.getAttributeValue('itemMetadataProperties');
        return properties
            ? properties.split(',')
            : [];
    }

    get searchMetaDataProperties(): Array<string> {
        const properties = this.getAttributeValue('itemSearchMetadataProperties');
        return properties
            ? properties.split(',')
            : [];
    }

    get searchTerm(): string {
        return this._attributes['searchTerm'];
    }

    get groupingProperty(): string {
        if (angular.isDefined(this.getAttributeValue('groupingProperty')))
            return this.getAttributeValue('groupingProperty');
        return '';
    }

    private getAttributeValue(key: string): string {
        const value = this._attributes[key];
        return value === undefined || value === null
            ? undefined
            : value;
    }
}


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/core/directives/itemsList/models/itemsListOptions.ts
 **/